import { UI_TextComponent } from 'ui/components/3-organisms/TextComponent/TextComponent';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { textComponentMapper } from 'helpers/mappers';

export const TextComponentFeature: React.FC<Content.TextComponent> = (props) => {
	const dictionary = useDictionaryContext();

	return <UI_TextComponent {...textComponentMapper(props, dictionary)} />;
};
